import { BaseDataModel } from "@domain/CRM/BaseDataModel";

/** Airtable's {Type} single-select on Dropoffs: what kind of location the drop is. */
export const DROPOFF_TYPES = ["Custom Drop", "Lab", "Shipping Center", "UPS Access Point"] as const;
export type DropoffType = (typeof DROPOFF_TYPES)[number];

/** Airtable's {UPS vs Other} formula (UPS ⇔ {Labs}="All Labs"). Deliberately NOT derived from
 *  {Type}: 25 active UPS drops are typed "Custom Drop", and Airtable owns the rule. */
export const DROPOFF_SHIPPING_METHODS = ["UPS", "Courier/Other"] as const;
export type DropoffShippingMethod = (typeof DROPOFF_SHIPPING_METHODS)[number];

export class Dropoff extends BaseDataModel {
	name!: string;
	latitude!: number;
	longitude!: number;
	/** MC schedules only active locations. */
	active!: boolean;
	/** Human-readable address shown beside the name. */
	location!: string;
	/** "" while Airtable hasn't typed the location. */
	type!: DropoffType | "";
	/** "" when the formula is blank (never for a saved Airtable record; possible for test doubles). */
	shippingMethod!: DropoffShippingMethod | "";
}
